import React, { useEffect, useState } from 'react';
import {
  Row,
  Col,
  Container,
  Form,
  InputGroup,
  Button,
  Card,
  Collapse,
} from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUserPlus,
  faRefresh,
  faHourglassStart,
  faFileInvoice,
  faBox,
  faTruckFast,
  faCircleCheck,
  faPeopleCarry,
  faArrowUp,
  faArrowDown,
  faPenNib,
  faCity,
  faBusinessTime,
  faHourglassEnd,
  faClock,
  faSliders,
  faArrowRotateLeft,
} from '@fortawesome/free-solid-svg-icons';
// import TableOnly from "../../scheme-management/Components/IndividualScheme.js/TableOnly";
import { useLocation, useNavigate } from 'react-router-dom';
import ExportButton from '../orders/components/ExportButton';
import { t } from 'i18next';
import DatePicker from '../../tripPayments/DatePicker';
import { apiCall } from '../../../middlewares/api';
import { apiCallConsts } from '../../../constants/apiCallConsts';
import { useDispatch } from 'react-redux';
import { updateSpinnerState } from '../../../actions/spinner';
import { updateToastInfo } from '../../../actions/settings';
import EditableDropDown from '../../../components/common/EditableDropdown';
import { setPageNumberInStore } from '../../../actions/tablePage';
import TableOnly from '../../scheme-management/Components/IndividualScheme/TableOnly';
import { orderAssignedColumns, orderTableColumns } from '../orders/utils';
import { returnProductInfo } from '../../../utils/sms/tableUtils';

const NotifyMeData = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showFilters, setShowFilters] = useState(false);
  const [filterData, setFilterData] = useState({
    startDate: '',
    endDate: '',
  });
  const [startDate, setStartDate] = useState(
    convertDateToDDMMYYYY(new Date()?.getTime() - 10 * 24 * 60 * 60 * 1000)
  );
  const [endDate, setEndDate] = useState('');
  const [totalObj, setTotalObj] = useState([]);
  const [responseData, setResponseData] = useState({});
  const dispatch = useDispatch();
  const reportTypeArray = [];
  const fetchDate = async () => {
    try {
      dispatch(updateSpinnerState(true));
      dispatch(setPageNumberInStore({ id: 'Analytics Data', page: 1 }));
      const data = await apiCall(
        apiCallConsts?.GET_METHOD,
        `/internal/dashboard/getNotifyMeInsights?startDate=${startDate}&endDate=${endDate}`
      );
      console.log(data);

      setTableData(data?.data);
      setTotalObj(data?.totalEntries);
      setResponseData(data);
      dispatch(updateSpinnerState(false));
    } catch (error) {
      dispatch(updateSpinnerState(false));
      dispatch(
        updateToastInfo({
          show: true,
          type: 'danger',
          title: t('Failed Getting Products data'),
          message: t(error.message),
        })
      );
    }
  };
  const handleApplyFilters = () => {
    fetchDate();
  };
  const handleRefresh = () => {
    try {
      fetchDate();
    } catch (error) {}
  };

  const handleReset = () => {
    setStartDate('');
    setEndDate('');
    setTableData([]);
    setResponseData({});
  };
  useEffect((each) => {
    try {
      fetchDate();
    } catch (error) {}
  }, []);

  const [tableData, setTableData] = useState([]);
  const [selectedCard, setSelectedCard] = useState(null);

  return (
    <div
      className="h-100 w-100"
      style={{
        minHeight: '100vh',
        padding: '16px',
        backgroundColor: '#F5F8FB',
      }}
    >
      <Container fluid className="px-3">
        <div className="mb-4">
          <div className="mb-4">
            <div className="d-flex justify-content-between align-content-center text-center p-2 bg-white">
              <div className="fw-bold fs-5 mt-1">{t('NotifyMe Report')}</div>
              <div
                style={{ width: '19%' }}
                className="d-flex justify-content-between align-content-center text-center"
              >
                <ExportButton
                  style={{ marginInline: '10px' }}
                  data={tableData}
                  columns={[
                    { field: 'vanNo', key: 'vanNo' },
                    { field: 'productTitle', key: 'productTitle' },
                    {
                      field: 'pincode',
                      key: 'pincode',
                    },
                    {
                      field: 'mobileNumber',
                      key: 'mobileNumber',
                    },
                    {
                      field: 'email',
                      key: 'email',
                    },
                  ]}
                  fileName={`${startDate}-${endDate}-NotifyMe`}
                />
                <Button
                  variant="primary"
                  onClick={() => setShowFilters(!showFilters)}
                  aria-controls="filter-collapse"
                  aria-expanded={showFilters}
                >
                  <FontAwesomeIcon icon={faSliders} />
                  &nbsp;&nbsp;{t('Filter')}
                </Button>
              </div>
            </div>

            <Collapse in={showFilters}>
              <div
                id="filter-collapse"
                className="mt-3"
                style={{ backgroundColor: 'white', padding: 20 }}
              >
                <Form>
                  <div className="row">
                    <div className="col-md-4">
                      <Form.Label>START DATE</Form.Label>
                      <Form.Control
                        style={{
                          height: 38,
                          width: '100%',
                        }}
                        isInvalid={false}
                        required
                        type="date"
                        value={startDate}
                        defaultValue={null}
                        onChange={(event) => {
                          setStartDate(event.target.value);
                        }}
                        placeholder="Start Date"
                      />
                    </div>

                    <div className="col-md-4">
                      <Form.Label>END DATE</Form.Label>
                      <Form.Control
                        style={{
                          height: 38,
                          width: '100%',
                        }}
                        isInvalid={false}
                        required
                        value={endDate}
                        type="date"
                        defaultValue={null}
                        onChange={(event) => {
                          setEndDate(event.target.value);
                        }}
                        placeholder="End Date"
                      />
                    </div>
                  </div>
                  <div className="d-flex justify-content-end mt-3">
                    <Button
                      onClick={handleReset}
                      variant="white"
                      style={{
                        width: '150px',
                        height: '38px',
                        borderRadius: 0,
                        background: '#EAEDF2',
                        marginInline: '10px',
                      }}
                    >
                      <FontAwesomeIcon icon={faArrowRotateLeft} /> &nbsp;&nbsp;
                      Reset
                    </Button>

                    <Button
                      onClick={handleApplyFilters}
                      variant="white"
                      style={{
                        width: '150px',
                        height: '38px',
                        borderRadius: 0,
                        border: '1px solid #262B40',
                        marginInline: '10px',
                      }}
                      className="me-2"
                    >
                      <FontAwesomeIcon icon={faSliders} /> &nbsp;&nbsp; Apply
                      Filters
                    </Button>
                  </div>
                </Form>
              </div>
            </Collapse>
          </div>
        </div>

        <div
          className="d-flex flex-wrap gap-1 mb-3"
          style={{ justifyContent: 'space-between' }}
        >
          <Card
            className={`flex-grow-1 shadow-sm border-1 cursor-pointer transition-all ${
              selectedCard === 'totalOrders' ? 'border-primary shadow-lg' : ''
            }`}
            style={{ minWidth: '300px', maxWidth: '23%', cursor: 'pointer' }}
          >
            <Card.Body className="d-flex align-items-center justify-content-between">
              <div>
                <div className="text-muted small">Total Requests</div>
                <div className="h4 mb-0">{responseData?.totalEntries || 0}</div>
              </div>
              <FontAwesomeIcon icon={faCity} className="h4 mb-0" />
            </Card.Body>
          </Card>

          <Card
            className={`flex-grow-1 shadow-sm border-1 cursor-pointer transition-all`}
            style={{ minWidth: '300px', maxWidth: '23%', cursor: 'pointer' }}
          >
            <Card.Body className="d-flex align-items-center justify-content-between">
              <div>
                <div className="text-muted small">Top VanNo</div>
                <div className="h4 mb-0">{responseData?.topVanNo || 0}</div>
              </div>
              <FontAwesomeIcon icon={faClock} className=" h4 mb-0" />
            </Card.Body>
          </Card>

          <Card
            className={`flex-grow-1 shadow-sm border-1 cursor-pointer transition-all ${
              selectedCard === 'processedOrders'
                ? 'border-primary shadow-lg'
                : ''
            }`}
            style={{ minWidth: '300px', maxWidth: '23%', cursor: 'pointer' }}
          >
            <Card.Body className="d-flex align-items-center justify-content-between">
              <div>
                <div className="text-muted small">Top Second VanNo</div>
                <div className="h4 mb-0">
                  {responseData?.secondTopVanNo || 0}
                </div>
              </div>
              <FontAwesomeIcon icon={faTruckFast} className=" h4 mb-0" />
            </Card.Body>
          </Card>

          <Card
            className={`flex-grow-1 shadow-sm border-1 cursor-pointer transition-all ${
              selectedCard === 'delayedOrders' ? 'border-primary shadow-lg' : ''
            }`}
            style={{ minWidth: '300px', maxWidth: '23%', cursor: 'pointer' }}
          >
            <Card.Body className="d-flex align-items-center justify-content-between">
              <div>
                <div className="text-muted small">Top Pincode</div>
                <div className="h4 mb-0">{responseData?.topPincode || 0}</div>
              </div>
              <FontAwesomeIcon icon={faBusinessTime} className=" h4 mb-0" />
            </Card.Body>
          </Card>
        </div>
        <Card className="border-0 shadow-sm">
          <Card.Body>
            <TableOnly
              id="Analytics Data"
              data={tableData}
              columns={[
                {
                  dataField: 'vanNo',
                  text: 'vanNo',
                  sort: true,
                },
                {
                  dataField: 'productTitle',
                  text: 'Product',
                  formatter: (cell, row) => {
                    return returnProductInfo([cell]);
                  },
                },
                {
                  dataField: 'pincode',
                  text: 'pincode',
                },
                {
                  dataField: 'email',
                  text: 'email',
                },
              ]}
            />
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default NotifyMeData;

function convertDateToDDMMYYYY(dateString) {
  // Create a Date object from the input string
  const date = new Date(dateString);

  // Get day, month, and year components
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const year = date.getFullYear();

  // Format the date as dd/mm/yyyy
  return `${year}-${month}-${day}`;
}
